import base from './base';
import data from './data/userInfo';

const userInfoApi = {};

userInfoApi.getUserInfo = () => {
  console.log('getUserInfo', data.mypageInfo);
  return base.fetch(data.mypageInfo, 300);
};
userInfoApi.setUserInfo = (val) => {
  console.log('setUserInfo', val);
  return base.fetch(data.registryMypage, 300);
};
userInfoApi.modifyContact = (val) => {
  console.log('modifyContact', val);
  return base.fetch(data.modifyContact, 300);
};
userInfoApi.modifyBusinessTelno = (val) => {
  console.log('modifyBusinessTelno', val);
  return base.fetch(data.modifyBusinessTelno, 300);
};
userInfoApi.modifyBusinessEmail = (val) => {
  console.log('modifyBusinessEmail', val);
  return base.fetch(data.modifyBusinessEmail, 300);
};
userInfoApi.modifyAccount = (val) => {
  console.log('modifyAccount', val);
  return base.fetch(data.modifyAccount, 300);
};
userInfoApi.modifyBusinessAccount = (val) => {
  console.log('modifyBusinessAccount', val);
  return base.fetch(data.modifyBusinessAccount, 300);
};
userInfoApi.getBusinessUserInfo = (val) => {
  console.log('mypagehistory', val);
  return base.fetch(data.mypagehistory, 300);
};
userInfoApi.delWithdrawalInfo = () => {
  console.log('delWithdrawalInfo');
  return base.fetch(data.delWithdrawalInfo, 300);
}

export default {
  ...userInfoApi,
};
